import { workerService } from 'js/services/worker.service';

import { TJackpots, IJackpot, IGetCasinoJackpotsParams, IGetExternalJackpotsParams } from './types';

export const getJackpots = (
    { jackpotsCasinoUrl, jackpotsCasino, currencyCode }: IGetCasinoJackpotsParams
): Promise<{ jackpots: TJackpots; casinoJackpot: IJackpot }> => workerService.request('jackpot', {
    currencyCode,
    url: `${jackpotsCasinoUrl}?casino=${jackpotsCasino}&currency=${currencyCode}&includeCasinoTotal=true`
});

export const getExternalJackpots = (
    { externalJackpotsCasinoUrl, externalJackpotsCasino, currencyCode, rgsId }: IGetExternalJackpotsParams
): Promise<Record<string, IJackpot>> => workerService.request('externalJackpot', {
    currencyCode,
    url: `${externalJackpotsCasinoUrl}?casino=${externalJackpotsCasino}&currency=${currencyCode}${rgsId ? `&rgsId=${encodeURIComponent(rgsId)}` : ''}`
});
